import axios from "axios";

export const fragments = {

    SCOPE_PROJECT: 'App\\Models\\Project',
    SCOPE_LEARNING_PATH: 'App\\Models\\LearningPath',
    SCOPE_CANVAS: 'App\\Models\\Canvas',

    async getByScope(scope){
        return axios.get('/api/fragment', {
            params: {
                scope,
            }
        });
    },

    async getById(fragment_id){
        return axios.get(`/api/fragment/${fragment_id}`);
    },


    async push(scope, fragments){
        return axios.post('/api/fragment', {
            scope,
            fragments,
        });
    }


};

export default fragments;
